<div class="sub-account-selector-dialog-content">
    <teg-dropdown [placeholder]="'Account'" [data]="accounts" [fields]="accountFields" 
                  (selectionChanged)="onAccountChanged($event)" >
    </teg-dropdown>
    <teg-dropdown [placeholder]="'Sub Account'" [data]="subAccounts" [fields]="subAccountFields" 
                  [(ngModel)]="selectedSubAccountGuid"
                  (selectionChanged)="onSubAccountChanged($event)" >
    </teg-dropdown>
</div>